import React from 'react'

function MainContent() {
   return (
      <section className="masthead -type-4 relative w-full h-full min-h-screen py-12 lg:py-0">
         <div className="container mx-auto max-w-[1530px] px-4 sm:px-6 h-full">
            <div className="flex flex-col lg:flex-row items-center justify-center h-full gap-8 lg:gap-12">
               {/* Partie image */}
               <div className="w-full lg:w-6/12 h-full lg:pl-[100px] mt-0 lg:mt-16 order-2 lg:order-1">
                  <div className="max-w-[500px] mx-auto lg:max-w-none">
                     <img
                        src="/404/1.svg"
                        alt="Illustration 404"
                        className="w-full max-w-full h-auto"
                     />
                  </div>
               </div>
               {/* Partie texte */}
               <div className="w-full lg:w-5/12 lg:ml-[120px] order-1 lg:order-2 text-center lg:text-left">
                  <h1 className="text-[120px] sm:text-[160px] lg:text-[200px] font-bold leading-none dark:text-white text-dark-1">
                     40<span className="text-[#6440FB]">4</span>
                  </h1>

                  <h2 className="text-dark-1 font-bold text-xl sm:text-2xl dark:text-white mt-4">
                     Oops! It looks like you're lost.
                  </h2>
                  <p className='mt-2 text-gray-500 dark:text-gray-300 text-base sm:text-lg'>
                     The page you're looking for isn't available. Try to search again or use the go to.
                  </p>

                  <div className="flex justify-center lg:justify-start gap-5 mt-8">
                     <a
                        href="/"
                        className="button bg-purple-1 border-2 hover:bg-white text-white font-medium
                        py-3 px-6 sm:py-4 sm:px-10 rounded-xl border-purple-1 transition-colors 
                        hover:text-purple-1 text-sm sm:text-base"
                     >
                        Go Back To Homepage
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default MainContent